<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">
            <h1 class="mu-mb-00">Roles</h1>
            <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p>
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                        </div>
                    </details>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Users & groups</li>
                <li>Roles</li>
                <li class="lastBredCrumpLi">
                </li>
            </ol>
        </nav>
      
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-card">
                        <div class="mcc-card__body">
                            <mcc-data-table ref="rolesTable" id="rolesTableId"></mcc-data-table>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import RoleAPI from "../../../services/RoleAPI";
import Table from "@advanced/component-mosaic-table";
import Utils from "@/script_utils";

export default {
    name: "RoleList",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["roles.list"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            tableData: [],
            filterActive: false,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.initRolesTable();

        // if (this.$refs.rolesTable.isReady) {
        //     this.initRolesTable();
        // } else {
        //     var self = this;
        //     this.$refs.rolesTable.addEventListener("ready", function () {
        //         self.initRolesTable();
        //     });
        // }
    },
    methods: {
        updateOrderList(filteredOrderList) {
            this.filterData = filteredOrderList;
            this.filterActive = true;
            this.initRolesTable();

        },
        filterFunctionList(filteredRows, filterValue) {
            
            this.roleName = filterValue;
            this.initRolesTable();
            this.roleName = "";
            return filteredRows.filter(function (r) {
                return (
                    ((r.roleName !== null) && r.roleName.toString().toLowerCase().includes(filterValue.toLowerCase())) ||
                    ((r.compositeRolesCSV !== null) && r.compositeRolesCSV.toString().toLowerCase().includes(filterValue.toLowerCase()))
                );
            })
        },
        submitDialog(e) {
            e.detail.instance.close();
            this.initRolesTable();
        },
        closeDialog() {
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        updateTemplate() {
            var self = this;
            this.$refs.rolesTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        var targetEle = e.target;
                        if (targetEle != null) {
                            var reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/usersgroups/roles/" + reference.trim()
                            );
                        }
                    });
                });
        },
        initRolesTable() {
            var self = this;
            self.updateCall = false;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("rolesTableId"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No roles found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        roleName: {
                            type: "string",
                            title: "Role name",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{roleName}}">{{roleName}}</a>',
                            columnSearch: false
                        },
                        compositeRolesCSV: {
                            type: "string",
                            title: "Composite roles",
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }

                        return RoleAPI.getRoles().then(result => {
                            var responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        self.updateCall = true;
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
